import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 1280px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Th160 = styled(ThItem)`
  width: 160px;
`;

const Th240 = styled(ThItem)`
  width: 240px;
`;

const Header = props => {
  
  return (
    <THead>
      <TableRow>
        <Th120>申請人</Th120>
        <Th120>工作日期</Th120>
        <Th240>起訖時間</Th240>
        <Th160>加班工時(時)</Th160>
        <Th160>加權工時(時)</Th160>
        <Th120>時薪</Th120>
        <Th120>應發加班費</Th120>
        {/* <Th240>跨組</Th240> */}
      </TableRow>
    </THead>
  );
};

export default Header;
